import { createContext } from 'react';

interface ILoadingAnimationContext {
  readonly toggleLoadingAnimation: (isVisible: boolean, id: UUID) => void;
  readonly isVisibleLoadingAnimation: boolean;
}

export const LoadingAnimationContext =
  createContext<ILoadingAnimationContext | undefined>(undefined);
